// Planning (R-PLA-01 à R-PLA-06) : jours de progression, grille des 13 semaines, semaines off.
import { useMagasin, magasin } from '../donnees/magasin';
import { jourPedagogique, formaterDate, semaineIso } from '@partage/dates';
import { grilleRegularite, prochainCreneau, serieRegularite, numeroSemaineCalendaire } from '@partage/programme';
import { GrilleRegularite } from '../composants/GrilleRegularite';

const JOURS = [[1, 'Lundi'], [2, 'Mardi'], [3, 'Mercredi'], [4, 'Jeudi'], [5, 'Vendredi'], [6, 'Samedi'], [7, 'Dimanche']] as const;

export function Planning() {
  const { etat, bundles } = useMagasin();
  const bundle = bundles[etat.saison_courante];
  const aujourdhui = jourPedagogique(new Date());
  const grille = grilleRegularite(etat, etat.saison_courante, aujourdhui);
  const semaineCal = numeroSemaineCalendaire(etat, etat.saison_courante, aujourdhui);

  async function basculerJour(j: number) {
    const jours = etat.parametres.jours.includes(j) ? etat.parametres.jours.filter((x) => x !== j) : [...etat.parametres.jours, j];
    if (!jours.length) return;
    await magasin.emettre('parametres_modifies', { jours });
  }

  async function basculerOff(semaine: string) {
    await magasin.emettre(etat.semaines_off.includes(semaine) ? 'semaine_off_retiree' : 'semaine_off_marquee', { semaine });
  }

  return (
    <>
      <h2>Planning</h2>
      <div className="grille">
        <div className="carte">
          <h3>Mes créneaux de progression</h3>
          <div className="ligne">
            {JOURS.map(([n, nom]) => (
              <label key={n} style={{ fontWeight: 400 }}><input type="checkbox" checked={etat.parametres.jours.includes(n)} onChange={() => void basculerJour(n)} />{nom}</label>
            ))}
          </div>
          <label style={{ fontWeight: 400, marginTop: '0.6em' }}><input type="checkbox" checked={etat.parametres.vendredi} onChange={(e) => void magasin.emettre('parametres_modifies', { vendredi: e.target.checked })} />Vendredi facultatif (défi, soutenance, rattrapage) — jamais compté comme manqué</label>
          <p style={{ marginTop: '0.8em' }}>Prochain créneau : <strong>{formaterDate(prochainCreneau(etat, aujourdhui))}</strong></p>
          <p className="petit-texte doux">Les sessions ne sont jamais assignées à une date : seules les dates réelles de réalisation comptent (R-PLA-06).</p>
        </div>
        <div className="carte">
          <h3>Saison {etat.saison_courante} · semaine calendaire {semaineCal ?? '—'} / 13</h3>
          <GrilleRegularite grille={grille} auClic={(s) => void basculerOff(s.semaine)} />
          <p className="petit-texte doux">Série : {serieRegularite(grille, aujourdhui)} semaine(s) complète(s) d’affilée. Clique une semaine pour la marquer « off » (ou l’inverse). Semaine 12 = tampon, semaine 13 = off.</p>
        </div>
      </div>
      <div className="carte" style={{ marginTop: '1em' }}>
        <h3>Semaine par semaine</h3>
        {grille.length === 0 ? <p className="vide">Active la saison depuis le tableau de bord.</p> : grille.map((s) => {
          const realisations = etat.progression.realisations.filter((r) => semaineIso(r.le.slice(0, 10)) === s.semaine);
          const semaineContenu = bundle?.semaines.find((w) => w.numero === s.numero);
          return (
            <div className="planning-semaine" key={s.semaine}>
              <strong>S{s.numero}</strong>
              <div>
                <div>{s.numero <= 11 ? semaineContenu?.theme ?? '' : s.numero === 12 ? 'Semaine tampon (rattrapage)' : 'Semaine off'} <span className="petit-texte doux">· {s.semaine}</span></div>
                <div className="points">{realisations.map((r, i) => <span key={i} className={r.mode === 'faible_energie' ? 'faible' : ''} title={`${r.session} · ${r.mode === 'faible_energie' ? 'faible énergie' : 'standard'} · ${new Date(r.le).toLocaleDateString('fr-FR')}`} />)}{s.defi ? ' ★' : ''}</div>
              </div>
              <span className={`badge ${s.statut === 'complete' ? 'ok' : s.statut === 'partielle' ? 'accent' : ''}`}>{s.statut}</span>
            </div>
          );
        })}
      </div>
    </>
  );
}
